import { useParams } from "react-router-dom";

export const FormateDate = ({ date }) => {
  let { lang } = useParams();

  return new Date(date).toLocaleString(lang, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: 'numeric', hour12: true });
};
